import { FormattedMessage } from 'react-intl';
import { ValueOf } from 'types';
import { Icon } from '../../icon/Icon';

import * as S from './Popup.styles';

export const STATUS = {
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
} as const;

export interface PopupProps {
  readonly isActive?: boolean;
  readonly message: string;
  readonly details?: string;
  readonly onClose?: () => void;
  readonly status: ValueOf<typeof STATUS>;
}

const Popup = ({ isActive, message, details, onClose, status }: PopupProps): JSX.Element => (
  <S.PopupWrapper isActive={isActive}>
    <S.PopupCross onClick={onClose}>
      <Icon iconName="Cross" />
    </S.PopupCross>
    {((): JSX.Element => {
      switch (status) {
        case STATUS.SUCCESS:
          return (
            <>
              <p>
                <FormattedMessage id="success" />
              </p>
              <S.PopupMessageSuccess>
                <S.PopupMessageIcon>
                  <Icon iconName="Check" />
                </S.PopupMessageIcon>
                <p>{message}</p>
              </S.PopupMessageSuccess>
            </>
          );
        case STATUS.ERROR:
          return (
            <>
              <p>
                <FormattedMessage id="error" />
              </p>
              <S.PopupMessageError>
                <S.PopupMessageIcon>
                  <Icon iconName="Alert" />
                </S.PopupMessageIcon>
                <p>{message}</p>
              </S.PopupMessageError>
            </>
          );
      }
    })()}
    <S.PopupDetails>{details}</S.PopupDetails>
  </S.PopupWrapper>
);

//Lazy needed for Lazy import
export default Popup;
